import * as React from "react";
import useSWR from "swr";
import { getPostHogDistinctId } from "../services/posthogCapture";
import fetcher from "./fetcher";

const baseEndpoint = `${import.meta.env.VITE_DISCOVER_API_ENDPOINT}/v1/search`;

export function createQuery({ query, include, source }) {
  if (!query) {
    return "";
  }

  const params = new URLSearchParams({ source });

  if (Array.isArray(include)) {
    include.forEach((includeValue) => {
      params.append("include", includeValue);
    });
  } else {
    params.set("include", include);
  }

  params.set("q", query);

  const phId = getPostHogDistinctId();
  if (phId) {
    params.set("ph_distinct_id", phId);
  }

  return params;
}

export const INCLUDES = Object.freeze(
  Object.seal({
    INFLUENCERS: "influencers",
    PRODUCTS: "products",
    FRANCHISES: "franchises",
    CHARACTERS: "characters",
  }),
);

export default function useSearch(
  query,
  include = INCLUDES.INFLUENCERS,
  source = "search-nav",
) {
  const params = createQuery({ query, include, source });
  const { data, error, mutate } = useSWR(
    params ? `${baseEndpoint}?${params}` : null,
    fetcher,
  );

  const results = React.useMemo(() => {
    if (!data?.results) {
      return {
        influencers: [],
        products: [],
        franchises: [],
        characters: [],
      };
    }

    return {
      influencers: data.results.influencers?.hits ?? [],
      products: data.results.products?.hits ?? [],
      franchises: data.results.franchises?.hits ?? [],
      characters: data.results.characters?.hits ?? [],
    };
  }, [data]);

  return {
    results,
    isLoading: !data && !error,
    isError: Boolean(error),
    error,
    refresh: mutate,
  };
}
